<template>
  <div class="borrowers">
    <div v-if="!borrowerList.length" class="no-data">
      No Data
    </div>
    <div v-for="(item, index) in borrowerList" :key="index" class="item">
      <div class="item-group">
        <div class="item-content">{{ item.fullName }}</div>
        <div class="item-content">{{ item.passportNo }}</div>
      </div>
      <div class="item-group">
        <div class="item-content">{{ item.fullName }}</div>
        <div class="item-content">{{ item.fullName }}</div>
      </div>
      <div class="item-group">
        <div class="item-content">
        </div>
        <div class="item-content">
          <div v-if="$route.query.orderType === 'EVENT_TRIAL'">--</div>
          <div v-else class="outer-link" @click="goToAgreement(item)">
            {{ $t('loanAgreement') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  i18n: {
    messages: {
      en: {
        agreement: 'Agreement',
        borrowerName: 'Name of the borrower',
        idNumber: 'ID Number',
        investmentAmount: 'Total Lending Commitment',
        investmentDetail: 'Lending Detail',
        loanAgreement: 'Loan Agreement',
        phone: 'Phone Number',
      },
      id: {
        agreement: 'Perjanjian',
        borrowerName: 'Nama peminjam',
        idNumber: 'KTP No.',
        investmentAmount: 'Jumlah pendanaan',
        investmentDetail: 'Detil Pendanaan',
        loanAgreement: 'Perjanjian Pinjaman',
        phone: 'Telepon',
      },
    },
  },
  components: {},
  data() {
    return {
      borrowerList: [],
    }
  },
  computed: {
    currencyType() {
      return this.$store.state.currency
    },
  },
  async mounted() {
    await this.reloadBorrowerData()
  },
  methods: {
    async reloadBorrowerData() {
      try {
        const params = {
          investedOrderId: this.$route.query.orderId,
          pageNum: 1,
          pageSize: 100,
        }
        const response = await this.$http.get('/agreement/borrowers', { params })
        this.borrowerList = response.data.data.map(value => {
          return {
            fullName: value.fullName,
            mobileNumber: value.mobileNumber,
            amount: value.amount,
            loanPrincipal: value.loanPrincipal,
            passportNo: value.idNumber,
            kpOrderId: value.kpOrderId,
            kpChannel: value.kpChannel,
            issueTimestamp: value.issueTimestamp,
            digiSignDocumentId: value.digiSignDocumentId ? value.digiSignDocumentId : '',
          }
        })
      } catch (error) {
        console.error(error)
      }
    },
    async goToAgreement(row) {
      if (this.$config.needElectronicContract && row.digiSignDocumentId) {
        this.$router.push({
          name: 'AgreementPreview',
          query: { orderId: row.orderId, documentId: row.digiSignDocumentId },
        })
        return
      }
      console.log('kp order id:', row.kpOrderId)
      const language = this.$i18n.locale
      const path = row.kpChannel === 'NKP' ? '/static/html/loan-agreement/loan-agreement-new.html' : `/static/html/loan-agreement/loan-agreement-${language}.html`
      const url = `${path}?loanAmount=${row.amount}&loanPrincipal=${row.loanPrincipal}&orderId=${this.$route.query.orderId}&kpOrderId=${row.kpOrderId}&kpChannel=${row.kpChannel}&issueTimestamp=${row.issueTimestamp}`
      window.open(url, '_blank')
    },
  },
}
</script>

<style lang="stylus" scoped>
.borrowers {
  padding-top: 10px;
  background: #fff;
}

.item {
  padding: 10px;
  border-bottom: 1px solid #eee;
  &:last-child {
    border-bottom: 0;
  }
}

.item-group {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #666666;
  padding: 5px;
}

.outer-link {
  color: #468ee4;
}

.no-data {
  text-align: center;
  padding: 20px;
}
</style>
